
namespace TabAurous.Sales {

    
    @Serenity.Decorators.registerClass()
    export class SalesQuotationItemSelectGrid extends _Ext.GridBase<SalesQuotationItemsRow, any> {
        protected getColumnsKey() { return 'Sales.QuotationItems'; }
        protected getDialogType() { return SalesQuotationItemsDialog; }
        protected getIdProperty() { return SalesQuotationItemsRow.idProperty; }
        protected getInsertPermission() { return SalesQuotationItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesQuotationItemsRow.localTextPrefix; }
        protected getService() { return Sales.SalesQuotationItemsSelectService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {}; 
    

        constructor(container: JQuery, options) {
            super(container, options);

            (this.view.params as TransactionRequest).PartyId = options.GridFilters.PartyId;
            (this.view.params as TransactionRequest).InStock = options.GridFilters.InStock;
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }
        get selectedItems(): SalesOrder.SalesOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        } 

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        } 

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }

    } 
}